import React from 'react';
import { css } from '@emotion/react';

import SVG from '@newrelic/gatsby-theme-newrelic/src/components/SVG';

const DotNetMauiIcon = (props) => {
  return (
    <SVG
      {...props}
      viewBox="0 0 337 337"
      css={css`
        .d {
          fill: #fff;
        }
        .e {
          fill: #a213ec;
        }
      `}
    >
      <defs xmlns="http://www.w3.org/2000/svg" />
      <g xmlns="http://www.w3.org/2000/svg" id="a" />
      <g xmlns="http://www.w3.org/2000/svg" id="b">
        <g id="c">
          <rect className="e" width="337" height="337" />
          <path
            className="d"
            d="M287.42,153.84l-51.78-89.68c-2.27-5.67-8.32-9.16-14.87-9.16H117.22c-6.55,0-12.59,3.49-16.87,9.16l-51.78,89.68c-2.27,5.67-2.27,12.65,1,18.32l51.78,89.68c3.27,5.67,9.32,9.16,15.87,9.16h103.55c6.55,0,12.59-3.49,15.87-9.16l51.78-89.68c3.27-5.67,3.27-12.65-1-18.32Zm-40.7,51.16h-17.91c-1.16,0-2.23-.62-2.81-1.62l-33.45-57.94-9.96,17.9,18.35,31.79c1.25,2.16-.31,4.87-2.81,4.87h-17.91c-1.16,0-2.23-.62-2.81-1.62l-7.29-12.64-7.01,12.59c-.57,1.03-1.66,1.67-2.84,1.67h-17.75c-2.48,0-4.04-2.66-2.84-4.82l17.61-31.64-10.09-17.48-31.88,57.27c-.57,1.03-1.66,1.67-2.84,1.67h-17.75c-2.48,0-4.04-2.66-2.84-4.82l42.48-76.32,7.1-12.77,2.37-4.25c1.21-2.18,4.33-2.23,5.62-.1l10.72,17.8,9.58,16.6,9.96-17.9,9.69-17.4c1.23-2.2,4.39-2.23,5.65-.04l9.96,17.24,44.51,77.09c1.25,2.16-.31,4.87-2.81,4.87Z"
          />
        </g>
      </g>
    </SVG>
  );
};

export default DotNetMauiIcon;
